import { Box, Typography } from '@mui/material';
import { landingColors } from './landingTheme';

const ITEMS = [
  ['Signature Burger', '₱280'],
  ['Truffle Fries', '₱150'],
  ['Iced Caramel Latte', '₱130'],
  ['Margherita Pizza', '₱340'],
];

// Static CSS phone mockup shown when WebGL is unavailable or the user prefers
// reduced motion — keeps the hero meaningful without the 3D scene.
export default function PhoneFallback() {
  return (
    <Box
      aria-hidden
      sx={{
        width: { xs: 200, sm: 230 },
        mx: 'auto',
        borderRadius: '32px',
        bgcolor: '#15151f',
        border: `2px solid ${landingColors.indigo}`,
        p: 1,
        boxShadow: `0 30px 80px rgba(102, 126, 234, 0.35)`,
      }}
    >
      <Box sx={{ borderRadius: '24px', overflow: 'hidden', bgcolor: '#fff' }}>
        <Box sx={{ bgcolor: landingColors.indigo, color: '#fff', p: 2 }}>
          <Typography sx={{ fontWeight: 800, fontSize: '1rem' }}>merchQRy</Typography>
          <Typography sx={{ fontSize: '0.7rem', opacity: 0.85 }}>Table 12 • Dine-in</Typography>
        </Box>
        <Box sx={{ p: 1.5 }}>
          {ITEMS.map(([name, price], i) => (
            <Box
              key={name}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: landingColors.paperAlt,
                borderRadius: '12px',
                p: 1,
                mb: 1,
              }}
            >
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: '8px',
                  bgcolor: i % 2 === 0 ? landingColors.indigo : '#c9cdf6',
                  flexShrink: 0,
                }}
              />
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: landingColors.ink, flex: 1 }}>
                {name}
              </Typography>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: landingColors.indigo }}>
                {price}
              </Typography>
            </Box>
          ))}
          <Box
            sx={{
              mt: 1,
              bgcolor: landingColors.indigo,
              color: '#fff',
              textAlign: 'center',
              borderRadius: '14px',
              py: 1,
              fontWeight: 700,
              fontSize: '0.8rem',
            }}
          >
            Place Order
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
